document.addEventListener("DOMContentLoaded", function(event) {

   if (document.getElementById('snap')) {

    console.log('snapping')

    var snapButton = document.getElementById('snap')

    const viewfinder = document.getElementById("viewfinder")
    const preview = document.getElementById("previewx")
    const snap = document.getElementById("snap")
    const formdata = document.getElementById("formdata")
    const newpicButton = document.getElementById("newpic")

    var target = document.getElementById("item_campic")
    if (!target)
      target = document.getElementById("container_campic")

    var constraints = {
      audio: false,
      video: {
        facingMode: { ideal: 'environment' },
        width: { ideal: 4096 },
        height: { ideal: 2160 }
      }
    }

    var imageCapture;

    navigator.mediaDevices.getUserMedia(constraints).then((stream) => {
      document.querySelector('video').srcObject = stream;
      const track = stream.getVideoTracks()[0];
      imageCapture = new ImageCapture(track);
    })


  if (snapButton) {
    snapButton.onclick = function () {


      imageCapture.takePhoto()
      .then(blob => {
        var reader = new FileReader();
        reader.readAsDataURL(blob);
        reader.onloadend = function() {
          var base64data = reader.result;

          let input:any = target;
          input.setAttribute('value', base64data)
        }

        toggle(viewfinder)
        toggle(preview)
        toggle(snap)
        toggle(formdata)

        return createImageBitmap(blob)
      })
      .then(imageBitmap => {
        const canvas = document.querySelector('#takePhotoCanvas');
        drawCanvas(canvas, imageBitmap);
      })
      .catch(error => console.log(error));
    }
  }

  if (newpicButton) {
    newpicButton.onclick = function () {
      toggle(viewfinder)
      toggle(preview)
      toggle(snap)
      toggle(formdata)
   };
  }
}

function toggle(x) {
  if (x.style.display === "none") {
    x.style.display = "block";
  } else {
    x.style.display = "none";
  }
}

function drawCanvas(canvas, img) {
  canvas.width = getComputedStyle(canvas).width.split('px')[0];
  canvas.height = getComputedStyle(canvas).height.split('px')[0];

  let ratio  = Math.min(canvas.width / img.width, canvas.height / img.height);
  let x = (canvas.width - img.width * ratio) / 2;
  let y = (canvas.height - img.height * ratio) / 2;
  canvas.getContext('2d').clearRect(0, 0, canvas.width, canvas.height);
  canvas.getContext('2d').drawImage(img, 0, 0, img.width, img.height,
      x, y, img.width * ratio, img.height * ratio);
}

// document.querySelector('video').addEventListener('play', function() {
//   document.querySelector('#grabFrameButton').disabled = false;
//   document.querySelector('#takePhotoButton').disabled = false;
// });

 })


